module.exports = __webpack_public_path__ + "13d6ad40506c2496f28e1a944fe734fc.svg";